'use client';

import React from 'react';
import {
    ChakraProvider,
    Flex,
    Box,
    Heading,
    Text,
    Icons,
    Link,
    HStack,
} from '@shared/ui';
import i18n from '@shared/i18n';
import { GeneralEnhancePage } from 'app/base/GeneralEnhancePage';
import { PageLayoutDetail } from 'app/shop-ui/types';

interface PageNotFoundProps {
    config: {
        brandMeta: Brand;
        taxInfo: TaxInfoResponse['data'];
    };
    headerLayout: PageLayoutDetail;
    footerLayout: PageLayoutDetail;
    isProduct?: boolean;
}

export default function PageNotFound(props: PageNotFoundProps) {
    const { config, headerLayout, footerLayout, isProduct } = props;

    return (
        <GeneralEnhancePage
            config={config}
            headerLayout={headerLayout}
            footerLayout={footerLayout}
            isNotFound
        >
            <ChakraProvider>
                <Flex alignItems="center" justifyContent="center">
                    <Box
                        w="100%"
                        maxW="600px"
                        mx="auto"
                        px="m"
                        py="xl"
                        textAlign="center"
                    >
                        {isProduct && (
                            <>
                                <HStack
                                    mt="9px"
                                    color="neutral.100"
                                    justifyContent="center"
                                    gap="15px"
                                >
                                    <Icons.csr.ShoppingBag size="60px" weight="bold" />
                                    <Heading
                                        fontSize={{
                                            base: '24px',
                                            md: '30px',
                                        }}
                                        color="neutral.120"
                                        lineHeight="1.5"
                                    >
                                        {i18n.gettext('找不到商品')}
                                    </Heading>
                                </HStack>
                                <Box mt="21px">
                                    <Text
                                        fontSize="16px"
                                        color="neutral.080"
                                        lineHeight="1.5"
                                    >
                                        {i18n.gettext(
                                            '此商品可能已經被下架或刪除，嘗試瀏覽其他商品吧！'
                                        )}
                                    </Text>
                                </Box>
                                <Box mt="24px">
                                    <Link href="/browse">
                                        {i18n.gettext('查看全部商品')}
                                    </Link>
                                </Box>
                            </>
                        )}
                        {!isProduct && (
                            <>
                                <HStack
                                    mt="9px"
                                    color="neutral.100"
                                    justifyContent="center"
                                    gap="15px"
                                >
                                    <Icons.csr.SmileyXEyes size="60px" weight="bold" />
                                    <Heading
                                        fontSize={{
                                            base: '24px',
                                            md: '30px',
                                        }}
                                        color="neutral.120"
                                        lineHeight="1.5"
                                    >
                                        {i18n.gettext('找不到頁面')}
                                    </Heading>
                                </HStack>
                                <Box mt="21px">
                                    <Text
                                        fontSize="16px"
                                        color="neutral.080"
                                        lineHeight="1.5"
                                    >
                                        {i18n.gettext(
                                            '此頁面網址失效導致我們找不到該頁面，請嘗試回到首頁或瀏覽其他頁面！'
                                        )}
                                    </Text>
                                </Box>
                                <Box mt="24px">
                                    <Link href="/">{i18n.gettext('回首頁')}</Link>
                                </Box>
                            </>
                        )}
                    </Box>
                </Flex>
            </ChakraProvider>
        </GeneralEnhancePage>
    );
}
